export default {
  frameFilter: {
    filterTitle: 'フィルター',
  },
  frameLoop: {
    cycleIndex: 'ループ回数',
    title: '再生設定',
    sequence: '回数',
    LoopPlayback: '無限ループ',
  },
  perFrameDrag: {
    addTitle: '画像を追加',
    playAction: 'シーケンスフレームの再生',
    stopAction: 'シーケンスフレームの一時停止',
    frameTitle: '各フレームの画像',
    removeImageWarn: 'シーケンスフレームには少なくとも1枚の画像が必要です',
    uploading: 'アップロード中...',
  },
  perFrameInterval: {
    frameTitle: '各フレームの再生間隔',
  },
}
